import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { TaggedUserModel } from 'src/app/model/tagged-user.model';
import { BindService } from 'src/app/service/bind.service';

@Component({
  selector: 'app-bindings',
  template: '<ng-template></ng-template>'
})
export class BindingsComponent extends ComponentBase implements OnInit {

  constructor(private bindService: BindService) { 
    super() 
  }

  ngOnInit() {
    this.bindService.load(this.attribute)
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   const policiesChange: SimpleChange = changes.policies;
  //   if (policiesChange && 
  //       policiesChange.currentValue && 
  //       this.attribute.attributes.length == 0) {
  //         // this.loadBindings()
  //   }
  // }
}
